"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
/**
 * 用来封装返回值
 */
var Result = /** @class */ (function () {
    function Result(error, data) {
        if (error) {
            this.error = error;
        }
        if (data !== undefined) {
            this.data = data;
        }
    }
    return Result;
}());
exports.Result = Result;
